module.exports = __webpack_public_path__ + "img/pic_stays_3.582e9acb.jpg";